export default __webpack_public_path__ + "static/office-building-1026497_1280-f99ff958296d77514ea65bad8cb176b5.png";